// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","image":"App_image__m+DX6"};